import { ReadStoreItemDto, ReadCategoryDto, ReadStoreItemComboDto } from '@goparrot/storeitems-sdk';
import { StoreItemTypeEnum } from '@goparrot/storeitems-sdk';

export function isStoreItem(item: ReadStoreItemDto | ReadCategoryDto | ReadStoreItemComboDto): item is ReadStoreItemDto {
  return StoreItemTypeEnum.STORE_ITEM === item.type;
}
